import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';

import CSIO_standardsbar_graphic from '../../../assets/images/CSIO_standardsbar_graphic.png';

const DataStandards = () => (
  <Container>
    <Row>
      <Col xs={2} />
      <Col xs={8}>
        <div style={{
          backgroundColor: '#C5CBAF',
          padding: 12,
          fontSize: 28,
          fontFamily: 'Montserrat Medium',
          color: 'white',
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%'
        }}>
          CSIO DATA STANDARDS CERTIFICATION
        </div>
      </Col>
      <Col xs={2} />
    </Row>
    <Row>
      <Col style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <img
          src={CSIO_standardsbar_graphic}
          style={{
            width: '80%',
            height: 'auto',
            marginTop: 12
          }}
          alt=""
        />
      </Col>
    </Row>
    <Row style={{ height: '100%' }}>
      <PersonalLines />
      <CommercialLines />
      <Certification />
      <NewCommercial />
    </Row>
  </Container>
);

export default DataStandards;

const PersonalLines = () => (
  <Col style={{ marginTop: 12 }}>
    <div style={{
      backgroundColor: '#F0F2EB',
      padding: 12,
      height: '100%',
      minHeight: 164
    }}>
      <div style={{
        fontSize: 18,
        fontFamily: 'Montserrat SemiBold',
        color: '#004761',
        textAlign: 'center',
      }}>
        eDOCS: PERSONAL LINES
    </div>
      <div style={{
        fontSize: 16,
        fontFamily: 'Montserrat Medium',
        // color: '#004761',
        textAlign: 'center',
      }}>
        (September 2013)
    </div>
    </div>

  </Col>
)

const CommercialLines = () => (
  <Col style={{ marginTop: 12 }}>
    <div style={{
      backgroundColor: '#F0F2EB',
      padding: 12,
      minHeight: 164,
    }}>
      <div style={{
        fontSize: 18,
        fontFamily: 'Montserrat SemiBold',
        color: '#004761',
        textAlign: 'center',
      }}>
        eDOCS: COMMERCIAL LINES
    </div>
      <div style={{
        fontSize: 16,
        fontFamily: 'Montserrat Medium',
        // color: '#004761',
        textAlign: 'center',
      }}>
        (August 2015)
    </div>
    </div>

  </Col>
)

const Certification = () => (
  <Col style={{ marginTop: 12 }}>
    <div style={{
      backgroundColor: '#F0F2EB',
      padding: 12,
      minHeight: 164,
    }}>
      <div style={{
        fontSize: 18,
        fontFamily: 'Montserrat SemiBold',
        color: '#004761',
        textAlign: 'center',
      }}>
        CERTIFICATION OF COMPLIANCE:
    </div>
      <div style={{
        fontSize: 16,
        fontFamily: 'Montserrat Medium',
        color: '#004761',
        textAlign: 'center',
      }}>
        insurers eliminating Z-codes
    </div>
      <div style={{
        fontSize: 16,
        fontFamily: 'Montserrat Medium',
        // color: '#004761',
        textAlign: 'center',
      }}>
        (September 2017)
    </div>
    </div>

  </Col>
)

const NewCommercial = () => (
  <Col style={{ marginTop: 12 }}>
    <div style={{
      backgroundColor: '#F0F2EB',
      padding: 12,
      minHeight: 164,
    }}>
      <div style={{
        fontSize: 22,
        fontFamily: 'Montserrat Bold',
        color: '#004761',
        textAlign: 'center',
      }}>
        NEW!
    </div>
      <div style={{
        fontSize: 18,
        fontFamily: 'Montserrat SemiBold',
        color: '#004761',
        textAlign: 'center',
      }}>
        COMMERCIAL LINES DATA STANDARDS
    </div>
      <div style={{
        fontSize: 16,
        fontFamily: 'Montserrat Medium',
        // color: '#004761',
        textAlign: 'center',
      }}>
        (April 2021)
    </div>
    </div>

  </Col>
)

